import api from '../api/axios'

const base = (orgId, leilaoId, clienteId) =>
  `/organizadores/${orgId}/leiloes/${leilaoId}/comissao-prazo/${clienteId}`

const comissaoPrazoService = {
  async obter(orgId, leilaoId, clienteId) {
    const res = await api.get(base(orgId, leilaoId, clienteId))
    return res.data
  },

  async salvar(orgId, leilaoId, clienteId, prazoDias) {
    const res = await api.put(base(orgId, leilaoId, clienteId), { prazo_dias: prazoDias })
    return res.data
  },

  async remover(orgId, leilaoId, clienteId) {
    const res = await api.delete(base(orgId, leilaoId, clienteId))
    return res.data
  },

  async notaPromissoriaPdf(orgId, leilaoId, clienteId) {
    const resp = await api.get(`${base(orgId, leilaoId, clienteId)}/nota-promissoria`, {
      responseType: 'blob',
      timeout: 60000,
    })
    return resp.data
  },
}

export default comissaoPrazoService
